import { Button } from '@delmonicos/shared-design-system-react/src/components/button/button';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';
import {
  isAuthenticated,
  mustResetPassword,
} from '@app/core/authentication/authentication.slice';
import { logout } from '@app/core/helper/logout';
import { useAppDispatch, useAppSelector } from '@app/core/hooks';
import { UpdatePasswordForm } from '@app/feature/update-password/update-password.form';
import { useUpdatePassword } from '@app/feature/update-password/use-update-password';
import { useSetPageActionContext } from '@shared/layout/page-layout/page-layout-action.context-provider';

export const MustResetPasswordController = (): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const needResetPassword = useAppSelector(mustResetPassword);
  const isUserAuthenticated = useAppSelector(isAuthenticated);
  const setPageAction = useSetPageActionContext();
  const navigate = useNavigate();
  const { onSubmit, isLoading, isError } = useUpdatePassword({
    onSuccess: () => logout(dispatch, navigate),
  });

  const { t } = useTranslation();

  useEffect(() => {
    const actions = [];

    actions.push(
      <Button onClick={() => logout(dispatch, navigate)}>
        {t('$.must-reset-password.logout-action')}
      </Button>,
    );

    setPageAction(actions);
  }, [setPageAction, dispatch, navigate, t]);

  if (!needResetPassword) {
    return (
      <Navigate
        to={isUserAuthenticated ? APP_PATH.DASHBOARD : APP_PATH.LOGIN}
      />
    );
  }

  return (
    <UpdatePasswordForm
      title={t('$.update-password.must-reset.title')}
      caption=""
      isError={isError}
      onSubmit={onSubmit}
      isLoading={isLoading}
    />
  );
};
